export default __webpack_public_path__ + "static/media/tha.962df488.mp3";